import { buildWatcherStoreObject } from '../../utils';
import { getAllAlertsIds } from './getters';
import { newAlertReceived } from './actions';

const ALL_ALERTS_IDS = (state, getters) => getters[getAllAlertsIds.fullPath];
const ALERTS_IDS_CHANGED = (store, newVal, oldVal) => {
	const newAlertsReceived = newVal.length != oldVal.length;
	if (newAlertsReceived) {
		store.dispatch(newAlertReceived.fullPath);
	}
};

const watchers = [buildWatcherStoreObject(ALL_ALERTS_IDS, ALERTS_IDS_CHANGED)];

export default watchers;
